import aiUnderstandIcon from "./assets/ai-understand.png";
import crfIcon from "./assets/cfr.png";
import complianceIcon from "./assets/compliance-engine.png";
import knowledgeIcon from "./assets/knowledge-base.png";
import plansIcon from "./assets/plans.png";
import sourcesIcon from "./assets/sources.png";
import stateIcon from "./assets/state-local-laws.png";
import whatIDoIcon from "./assets/what-i-do.png";
import whatINeverDoIcon from "./assets/what-i-never-do.png";
import whatISeeIcon from "./assets/what-i-see.png";

export const SCOUT_INFO_PANEL_WIDTH_PX = 320;
export const SCOUT_KNOWLEDGE_BASE_URL = "https://support.encamp.com";

export type ScoutInfoPanelTab = "sources" | "method" | "privacy";

export type ScoutInfoPanelItem = {
  title: string;
  description: string;
  iconSrc: string;
};

export type ScoutInfoPanelContent = {
  title: string;
  subtitle: string;
  items: ScoutInfoPanelItem[];
};

export const SCOUT_SOURCES_CONTENT: ScoutInfoPanelContent = {
  title: "Scout's Sources",
  subtitle: "Learn more about where Scout gets its knowledge.",
  items: [
    {
      title: "Code of Federal Regulations (CFR)",
      description: "National environmental rules and reporting requirements.",
      iconSrc: crfIcon,
    },
    {
      title: "State & Local Laws",
      description: "Jurisdiction-specific rules, thresholds, and nuances.",
      iconSrc: stateIcon,
    },
    {
      title: "Encamp's Regulatory Knowledge",
      description: "Product guidance, support content, and internal regulatory know-how.",
      iconSrc: knowledgeIcon,
    },
    {
      title: "Compliance Engine",
      description: "The rules and applicability logic that power compliance decisions.",
      iconSrc: complianceIcon,
    },
  ],
};

export const SCOUT_METHOD_CONTENT: ScoutInfoPanelContent = {
  title: "How Scout finds answers",
  subtitle:
    "Scout researches each question agentically — closer to an advanced research assistant than a typical chatbot.",
  items: [
    {
      title: "Plans before answering",
      description:
        "Scout breaks each question into a research plan instead of guessing in a single shot. It decides what to look up, in what order, and when it has enough to answer.",
      iconSrc: plansIcon,
    },
    {
      title: "Researches many sources",
      description:
        "Scout pulls from the CFR, state and local rules, Encamp's regulatory knowledge, and your account — often citing dozens of sources to back a single answer.",
      iconSrc: whatIDoIcon,
    },
    {
      title: "Reasons step by step",
      description:
        "Between searches Scout uses substantial reasoning to follow leads, reconcile conflicting rules, and check its own work before responding.",
      iconSrc: aiUnderstandIcon,
    },
    {
      title: "Cites its work",
      description:
        "Each answer ends with the sources Scout drew from, so you can verify the reasoning and read the underlying material yourself.",
      iconSrc: sourcesIcon,
    },
  ],
};

export const SCOUT_PRIVACY_CONTENT: ScoutInfoPanelContent = {
  title: "How Scout uses your data",
  subtitle:
    "I'm committed to protecting your privacy and never share your data beyond the platform.",
  items: [
    {
      title: "What I can see",
      description:
        "I only have access to the data within your account, like government registrations. I use this to answer questions about your specific facilities to the best of my abilities.",
      iconSrc: whatISeeIcon,
    },
    {
      title: "What I can do",
      description:
        "I search through resources to answer your questions, summarize and distill those sources to gather information.",
      iconSrc: whatIDoIcon,
    },
    {
      title: "What I never do",
      description:
        "I never share your data, nor do I train on it. I never look at any sensitive data to generate answers for you.",
      iconSrc: whatINeverDoIcon,
    },
  ],
};
